<div class="shop-item" *ngFor="let product of myProductList">
    <div class="shop-item-media">
      <a [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]" height="291" title="{{product.sellProductTitle}}">
          <span *ngIf="!product.sellProductImageURL">
              <img alt="{{product.sellProductTitle}}" [src]="[serverImgUrl] + '/sellProducts/' + [product.sellProductImageURL] || '../../assets/images/shop/1.jpg'"/>
          </span>
          <span *ngIf="product.sellProductImageURL">
              <img alt="{{product.sellProductTitle}}" [src]="[serverImgUrl] + '/sellProducts/' + [product.sellProductImageURL] || '../../assets/images/shop/1.jpg'"/>
          </span>
          <div class="overlay"></div>
      </a>
      <div class="geodir_status_date gsd_open"><i class="fal fa-piggy-bank"></i>Sale {{product.sellProductDiscount}}%</div>
      <div class="add-tocart color-bg hide"><span>Add to cart</span></div>
      <div class="geodir-category-opt">
          <div class="listing-rating-count-wrap">
              <div class="review-score">{{feedAvg | number:'1.1-1'}}</div>
              <div class="listing-rating">
                <app-star-rating [rating]='feedAvg' [readonly]="true"></app-star-rating>
              </div>
              <br>
              <!-- <app-star-rating [rating='1'] [readonly]="false"></app-star-rating> -->
              <div class="reviews-count text-start"> {{feedTotal}} review </div>
          </div>
      </div>
    </div>
    <div class="shop-item_title"> 
      <h4> <a [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]"> {{product.sellProductTitle}}</a></h4>
      <p class="text-start fw-normal mb-2 short_info">{{product.sellProductDetails | shorten: 80: '...'}}</p>
      <span class="shop-item_price fs-6">
        <span class="product-header-details_price old-price">{{product.sellProductPrice | currency:"₹"}} </span> 
        <span class="product-header-details_price">{{product.sellProductPrice -((product.sellProductPrice * product.sellProductDiscount) / 100) | currency:"₹" }}</span>
      </span>
      <a [routerLink]="['/product-details', product.sellProductTitle | businessSlug, product.sellProductInfoId]" class="btn-primary btn btn-sm pull-right">Details </a>
    </div>  
  </div>
  <div class="alert alert-danger p-2 mb-0" *ngIf="!myProductList"> Your brand selling item or products does not have a published.</div>